// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    display: flex;
      justify-content: center;
    width: 95vw;
    margin-left: 2.5vw;
    
  }
  tr td:not(:first-child){
      padding-left:15px;
      padding-right:5px;
  }
  tr th:not(:first-child){
    padding-right:0px;
    text-align:center;
}
.full-width {
  width: 100%;
}

.mat-success {
  background-color: #76ff03;
  color: #000;
}

.mat-danger {
  background-color: #ff3d00;
  color: #00c2ff;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNvdXJjZS1tYW5hZ2VtZW50LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxhQUFhO01BQ1gsdUJBQXVCO0lBQ3pCLFdBQVc7SUFDWCxrQkFBa0I7O0VBRXBCO0VBQ0E7TUFDSSxpQkFBaUI7TUFDakIsaUJBQWlCO0VBQ3JCO0VBQ0E7SUFDRSxpQkFBaUI7SUFDakIsaUJBQWlCO0FBQ3JCO0FBQ0E7RUFDRSxXQUFXO0FBQ2I7O0FBRUE7RUFDRSx5QkFBeUI7RUFDekIsV0FBVztBQUNiOztBQUVBO0VBQ0UseUJBQXlCO0VBQ3pCLGNBQWM7QUFDaEIiLCJmaWxlIjoic291cmNlLW1hbmFnZW1lbnQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgd2lkdGg6IDk1dnc7XG4gICAgbWFyZ2luLWxlZnQ6IDIuNXZ3O1xuICAgIFxuICB9XG4gIHRyIHRkOm5vdCg6Zmlyc3QtY2hpbGQpe1xuICAgICAgcGFkZGluZy1sZWZ0OjE1cHg7XG4gICAgICBwYWRkaW5nLXJpZ2h0OjVweDtcbiAgfVxuICB0ciB0aDpub3QoOmZpcnN0LWNoaWxkKXtcbiAgICBwYWRkaW5nLXJpZ2h0OjBweDtcbiAgICB0ZXh0LWFsaWduOmNlbnRlcjtcbn1cbi5mdWxsLXdpZHRoIHtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbi5tYXQtc3VjY2VzcyB7XG4gIGJhY2tncm91bmQtY29sb3I6ICM3NmZmMDM7XG4gIGNvbG9yOiAjMDAwO1xufVxuXG4ubWF0LWRhbmdlciB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZjNkMDA7XG4gIGNvbG9yOiAjMDBjMmZmO1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/components/source-management/source-management.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;MACX,uBAAuB;IACzB,WAAW;IACX,kBAAkB;;EAEpB;EACA;MACI,iBAAiB;MACjB,iBAAiB;EACrB;EACA;IACE,iBAAiB;IACjB,iBAAiB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA,gnCAAgnC","sourcesContent":[":host {\n    display: flex;\n      justify-content: center;\n    width: 95vw;\n    margin-left: 2.5vw;\n    \n  }\n  tr td:not(:first-child){\n      padding-left:15px;\n      padding-right:5px;\n  }\n  tr th:not(:first-child){\n    padding-right:0px;\n    text-align:center;\n}\n.full-width {\n  width: 100%;\n}\n\n.mat-success {\n  background-color: #76ff03;\n  color: #000;\n}\n\n.mat-danger {\n  background-color: #ff3d00;\n  color: #00c2ff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
